const DottedLineUtils = require('./DottedLineUtils');

const DrawSVGUtils = require('../../../viscomjs/utils/DrawSVGUtils');
const utils = {};
DrawSVGUtils.mixin(utils);


module.exports.renderDottedCircle = el => {
    el.attr({r: el.data('r') * el.data('rRatio')});
    DottedLineUtils.renderDots(el, el.data('num'), 0);
};

module.exports.syncTransformWithRaduis = (el, c, delta) => {
    el.attr({transform: `translate(${c.data('r') + delta}, 0)`});
};

module.exports.syncRotation = (el, sourceEl) => {
    el.attr({transform: `rotate(${sourceEl.data('rotation')}, 0, 0)`});
};





// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/svgAnim/InvalidateUtils.js